import { ConfirmdeleteComponent } from './../../service/confirmdelete/confirmdelete.component';
// import { DialogService } from 'ng2-bootstrap-modal';
import { ManageService } from '../../service/manage.service';
import { sectors } from './../../service/sector.model';
import { DBConnectorService } from './../../service/test.service';
import { Component, OnInit } from '@angular/core';
import { LoggedInGuard } from '../../authentication/logged-in.guard';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-sectors',
  templateUrl: './sectors.component.html',
  styleUrls: ['./sectors.component.css']
})

export class SectorsComponent implements OnInit {
  bsModalRef: BsModalRef;
  public Sector = {
    'Id': null,
    'SectorName': null,
    'Description': null
  };

  Sector_SectorName: string;
  Sector_Description: string;

  CloneSector_SectorId: number;
  CloneSector_SectorName: string;
  CloneSector_Description: string;

  public CloneSector = {
    'CloneSectorId': null,
    'NewSectorName': null,
    'Description': null
  };

  public sectorlist = [];
  public result: any = {};
  tabSectorSelected = 'newsectors';

  onSectorSelector(tabName: string) {
    this.tabSectorSelected = tabName;
  }

  constructor(private getsector: DBConnectorService,
    private manage: ManageService,
    private _dialogService: BsModalService,
    private loggedInGuard: LoggedInGuard) {
  }

  ngOnInit() {
    this.getsectorlist();
  }

  getsectorlist() {
    if (this.loggedInGuard.isSessionValid()) {
      this.getsector.getsectors()
        .subscribe(res => {
          this.sectorlist = res;
          // console.log('this.sectorlist '+this.sectorlist);
        });
    }
  }

  SectorCreate() {
    if (this.loggedInGuard.isSessionValid()) {

      this.Sector.SectorName = this.Sector_SectorName;
      this.Sector.Description = this.Sector_Description;

      this.manage.createSector(this.Sector)
        .subscribe(
          (data) => {
            this.result = data;
            console.log(this.result);
            this.getsectorlist();
          });
    }
  }

  showConfirm(sect: sectors) {
    this.bsModalRef = this._dialogService.show(ConfirmdeleteComponent);
    this.bsModalRef.content.event.subscribe(isConfirmed => {
      if(isConfirmed) 
        this.SectorDelete(sect);
    })
    // const disposable = this.dialogService.addDialog(ConfirmdeleteComponent, {
    //   // title: 'Confirm title',
    //   // message: 'Confirm message'
    // })
    //   .subscribe((isConfirmed) => {
    //     // We get dialog result
    //     if (isConfirmed) {
    //       this.SectorDelete(sect);
    //     } else {
    //       // alert('declined');
    //     }
    //   });
    // We can close dialog calling disposable.unsubscribe();
    // If dialog was not closed manually close it by timeout
    // setTimeout(() => {
    //   disposable.unsubscribe();
    // }, 10000);
  }

  SectorDelete(sect: sectors) {
    if (this.loggedInGuard.isSessionValid()) {
      this.manage.deleteSector(sect)
        .subscribe(
          (data) => {
            this.result = data;
            console.log(this.result);
            this.getsectorlist();
          });
    }
  }

  cloneSectorCreate() {
    console.log(this.CloneSector);
    if (this.loggedInGuard.isSessionValid()) {
      this.CloneSector.CloneSectorId = this.CloneSector_SectorId;
      this.CloneSector.NewSectorName = this.CloneSector_SectorName;
      this.CloneSector.Description = this.CloneSector_Description;

      this.manage.createCloneSector(this.CloneSector).subscribe(
        (data) => {
          if (data === 'Please change the Clone Sector name') {
            alert(data);
          } else {
            this.result = data;
            console.log(data);
            this.getsectorlist();
          }
        });
    }
  }

}
